// extracted by mini-css-extract-plugin
export default {"portfolio":"Portfolio_portfolio__XIPO-","image":"Portfolio_image__PwYNv"};